module.exports = __webpack_public_path__ + "img/landing_bg.f43a1403.jpg";